// @flow

import { type PlanTier } from '@zapier/billing/src/types';

export default (tier: PlanTier): boolean => tier.pricePerTask === 0;
